import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["isWhite", "white", "size", "className", "css", "htmlProps"];
import React, { useMemo } from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import getSizeCss from "../helpers/getSizeCss";
import BASE_64 from "./Base64";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLoader = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y58qgd-0"
})(["\n  background-size: contain;\n  background-position: center;\n  background-image: url(", ");\n"], function (_ref) {
  var bgColor = _ref.bgColor;
  return BASE_64[bgColor];
});
var _StyledStyledLoader = /*#__PURE__*/styled(StyledLoader).withConfig({
  componentId: "sc-1y58qgd-1"
})(["\n        ", "\n        ", "\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});
var Loader = function Loader(_ref2) {
  var isWhite = _ref2.isWhite,
    white = _ref2.white,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 48 : _ref2$size,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    css = _ref2.css,
    htmlProps = _ref2.htmlProps,
    loaderProps = _objectWithoutProperties(_ref2, _excluded);
  var sizeCss = useMemo(function () {
    return getSizeCss(size);
  }, [size]);
  var loaderColor = isWhite || white ? 'white' : 'default';
  return /*#__PURE__*/_jsx(_StyledStyledLoader, _objectSpread(_objectSpread(_objectSpread({
    className: cn('flex-shrink-0', className)
    // @ts-ignore
    ,

    bgColor: loaderColor
  }, loaderProps), htmlProps), {}, {
    $_css: sizeCss,
    $_css2: css
  }));
};
export default Loader;